var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ItemPath",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ItemPath-Reports-Copy",
    transform: "translate(-323.000000, -250.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(323.000000, 250.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3AAB3",
    fillRule: "nonzero",
    cx: 19,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3AAB3",
    fillRule: "nonzero",
    cx: 13,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3AAB3",
    fillRule: "nonzero",
    cx: 8,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3AAB3",
    fillRule: "nonzero",
    cx: 2,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#A3AAB3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2 8 7.66666667 5 13.3333333 9 19 2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3AAB3",
    fillRule: "nonzero",
    cx: 19,
    cy: 15,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3AAB3",
    fillRule: "nonzero",
    cx: 13,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3AAB3",
    fillRule: "nonzero",
    cx: 8,
    cy: 13,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A3AAB3",
    fillRule: "nonzero",
    cx: 2,
    cy: 20,
    r: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#A3AAB3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2 20 7.66666667 13 13.3333333 19 19 15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon);
export default __webpack_public_path__ + "static/media/lineIcon.af3aa65ffc9f34ed753df8908a23b3f4.svg";
export { ForwardRef as ReactComponent };